import { render } from "./CornerComponent.vue?vue&type=template&id=a1dffc16&scoped=true"
const script = {}

import "./CornerComponent.vue?vue&type=style&index=0&id=a1dffc16&lang=css&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1dffc16"]])

export default __exports__